import { Box } from '@chakra-ui/react';
import { ModalBuildHandle } from 'components/molecules/ModalBuild/interfaces';
import { TableBuild } from 'components/organisms';
import { TableBuildActionsType } from 'components/organisms/TableBuild/type';
import { motion } from 'framer-motion';
import { ContractSearchResponseDTO } from 'models';
import { useEffect, useMemo, useRef, useState } from 'react';
import { DetailsModal } from '../../components/DetailsModal';

interface SearchResultTabProps {
  contracts: ContractSearchResponseDTO[]
  isLoading: boolean
  isError: boolean
  totalPages: number
  currentPage: number
  onPaginate: (page: number, limit: number) => void
}

export const SearchResultTab = ({
  contracts,
  isLoading,
  totalPages,
  currentPage,
  onPaginate
}: SearchResultTabProps) => {
  const [selectedContract, setSelectedContract] =
    useState<ContractSearchResponseDTO | null>(null)

  const modalRef = useRef<ModalBuildHandle>(null);

  const handleAction = (type: TableBuildActionsType, id: string | number) => {
    if (type === 'PREVIEW') {
      const contract = contracts[Number(id)];
      if (contract) {
        setSelectedContract({ ...contract });
      }
    }
  };

  useEffect(() => {
    if (selectedContract) {
      modalRef.current?.onOpen();
    }
  }, [selectedContract]);

  const handleCloseModal = () => {
      setSelectedContract(null); 
  }

  const tableData = useMemo(() => {
    const header = [
      { name: 'ufGravame', text: 'UF', position: 1 },
      { name: 'chassi', text: 'Chassi', position: 2 },
      { name: 'numeroContrato', text: 'Nº do Contrato', position: 3 }
    ]

    // A consulta BA pode omitir ID e número; a identificação aqui é só da linha exibida.
    const body = contracts.map((contract, index) => ({
      id: String(index),
      ufGravame: contract.ufGravame,
      chassi: contract.veiculo.chassi,
      numeroContrato: contract.numeroContrato || '–'
    }))

    const action = [
      {
        type: 'PREVIEW' as TableBuildActionsType,
        icon: 'file-alt' as const
      }
    ]

    return { header, body, action }
  }, [contracts])

   return (
    <>
      <Box as={motion.div} initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} mt={4}>
        <TableBuild
          header={tableData.header}
          body={tableData.body}
          action={tableData.action}
          loading={{
            status: isLoading,
            loader: [{ height: '20px' }, { height: '20px' }, { height: '20px' }]
          }}
          pagination={{
            page: currentPage,
            limit: 10,
            totalPages
          }}
          onAction={handleAction}
          onChangePage={page => onPaginate(page, 10)}
          onChangeLimit={limit => onPaginate(1, limit)}
        />  
      </Box>

      <DetailsModal
        ref={modalRef}
        onClose={handleCloseModal}
        contract={selectedContract}
      />
    </>
  );
};
